@if (
  (!isHidden && !config.hideIfZeroOrNull) ||
  (config.hideIfZeroOrNull && valueIsGreaterThanZero())
) {
  <div class="model-attribute">
    <div class="u-flex">
      @if (config.icon) {
        <icon class="model-attribute__icon" [name]="config.icon"> </icon>
      }

      <div
        tabindex="0"
        class="model-attribute__wrapper"
        [ngClass]="{
          'model-attribute__wrapper--row':
            direction === 'row' || direction === 'row_equal',
        }"
      >
        @if (
          !isLabelExcludedForThisFormat && !isLabelExcludedForThisComponent
        ) {
          <zipari-model-attribute-header
            [ngClass]="{
              'model-attribute-row-flex':
                direction === 'row' || direction === 'row_equal',
            }"
            [config]="config"
            [label]="label"
            [direction]="direction"
            [value]="value"
          ></zipari-model-attribute-header>
        }

        @if (!config.componentType) {
          <div class="model-attribute__value u-fillRemaining">
            @switch (displayType) {
              @case (displayTypes.ADDRESSES) {
                <div class="u-wrap model-attribute__multi-address">
                  @for (
                    addressValue of value;
                    track addressValue;
                    let idx = $index
                  ) {
                    <div class="multi-address__wrapper">
                      @if (
                        addressValue &&
                          addressValue.length > 1 &&
                          getAddressLabel(context, idx);
                        as label
                      ) {
                        @if (config.typeProp && config.useConfigAddressLabel) {
                          <h3
                            class="model-attribute__label__address model-attribute__Label"
                            [attr.for]="'address-' + idx"
                          >
                            <span [innerHTML]="label"></span>
                            <tooltip
                              class="model-attribute__tooltip"
                              [config]="config.tooltip"
                              data-test-id="modelAttributeTooltipForAddress"
                            ></tooltip>
                          </h3>
                        }
                      }
                      @if (addressValue) {
                        <p
                          [attr.id]="'address-' + idx"
                          [innerHTML]="addressValue"
                        ></p>
                      }
                    </div>
                  }
                </div>
              }
              @case (displayTypes.BOOLEAN_STRING_MAP) {
                <p
                  [attr.id]="label + ':' + value"
                  [innerHTML]="!!value ? config.truthyValue : config.falsyValue"
                ></p>
              }
              @case (displayTypes.EMAIL) {
                <a
                  [attr.id]="label + ':' + value"
                  [ngClass]="{
                    't-link': !config?.formatOptions?.noLink,
                    't-regular': config?.formatOptions?.noBold,
                  }"
                  [href]="'mailto: ' + value"
                  [innerHTML]="value"
                  (click)="onLinkClicked()"
                  role="link"
                  [attr.aria-label]="'link for: ' + label"
                  [attr.data-test-id]="'modelAttributeFor' + label"
                >
                </a>
              }
              @case (displayTypes.EXTERNAL_LINK) {
                <a
                  class="t-link"
                  [ngClass]="{ 't-bold': !label }"
                  [attr.id]="label + ':' + value"
                  [attr.target]="config.target ? config.target : '_blank'"
                  [href]="route || value"
                  [innerHTML]="text || value"
                  (click)="onLinkClicked()"
                  role="link"
                  [attr.aria-label]="'External link for: ' + label"
                  [attr.data-test-id]="
                    'modelAttributeForExternalLink' + (text || value)
                  "
                >
                </a>
              }
              @case (displayTypes.LINK) {
                <a
                  tabindex="0"
                  class="t-link"
                  [attr.id]="label + ':' + value"
                  [ngClass]="{
                    't-bold': !label || direction === 'row_equal',
                  }"
                  (click)="onLinkClicked()"
                  [innerHTML]="text || value"
                  role="link"
                  [attr.aria-label]="'link for: ' + label"
                  [attr.data-test-id]="
                    'modelAttributeForLink' + (text || value)
                  "
                >
                </a>
              }
              @case (displayTypes.LIST) {
                @if (valueIsList) {
                  <ul tabindex="0" class="model-attribute__list">
                    @for (val of value; track val) {
                      <li [attr.id]="label + ':' + value">
                        @switch (displaySubtype) {
                          @case (displayTypes.PHONE) {
                            <a
                              class="t-link"
                              [attr.href]="'tel: ' + val"
                              [innerHTML]="val"
                              (click)="onLinkClicked()"
                              role="link"
                              [attr.aria-label]="'link for: ' + label"
                              [attr.data-test-id]="
                                'modelAttributeForPhoneTypeListItem' + val
                              "
                            ></a>
                          }
                          @default {
                            <p>{{ val }}</p>
                          }
                        }
                      </li>
                    }
                  </ul>
                } @else {
                  <ul tabindex="0" class="model-attribute__list">
                    <li>
                      <p tabindex="0">
                        {{ config?.noValueMessage || 'n/a' }}
                      </p>
                    </li>
                  </ul>
                }
              }
              @case (displayTypes.PHONE_AND_TYPE) {
                @if (!value || value === config.noValueMessage) {
                  <p [attr.id]="label + ':' + value" [innerHTML]="value"></p>
                } @else {
                  @for (
                    phone_number_and_type of value;
                    track phone_number_and_type
                  ) {
                    <ul
                      class="model-attribute__list"
                      [attr.id]="label + ':' + value"
                    >
                      <li>
                        <a
                          tabindex="0"
                          [ngClass]="{
                            't-link': !config?.formatOptions?.noLink,
                            't-regular': config?.formatOptions?.noBold,
                          }"
                          [attr.href]="
                            config?.formatOptions?.noLink
                              ? null
                              : 'tel: ' + value
                          "
                          (click)="onLinkClicked()"
                          role="link"
                          [attr.aria-label]="'link for: ' + label"
                          [attr.data-test-id]="
                            'modelAttributeListItemForList' +
                            phone_number_and_type
                          "
                          [innerHTML]="phone_number_and_type"
                        >
                        </a>
                      </li>
                    </ul>
                  }
                }
              }
              @case (displayTypes.PHONE) {
                <a
                  tabindex="0"
                  [ngClass]="{
                    't-link': !config?.formatOptions?.noLink,
                    't-regular': config?.formatOptions?.noBold,
                  }"
                  [attr.id]="label + ':' + value"
                  [attr.href]="
                    config?.formatOptions?.noLink ? null : 'tel: ' + value
                  "
                  (click)="onLinkClicked()"
                  [innerHTML]="value"
                  role="link"
                  [attr.aria-label]="'link for: ' + label"
                  [attr.data-test-id]="'modelAttributeFor' + label"
                ></a>
              }
              @case (displayTypes.STATUS) {
                <status
                  [attr.id]="label + ':' + value"
                  [config]="{
                    label: value,
                    statuses: config.statuses,
                  }"
                >
                </status>
              }
              @case (displayTypes.VALUE_MAP) {
                <p [attr.id]="label + ':' + value" [innerHTML]="value"></p>
              }
              @default {
                <p
                  [attr.id]="label + ':' + value"
                  [innerHTML]="'&#8203;' + value"
                ></p>
              }
            }
          </div>
        } @else {
          @if (config.componentType === componentTypes.badge) {
            <badge [config]="badgeConfig" [context]="context"></badge>
          }
        }
      </div>
    </div>
  </div>
}
